import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { COLORS_MAP, COLORS_PROP_TYPE } from '@eventbrite/legacy-eds.styles/color';
import { DIVIDER_DIRECTIONS_PROP_TYPE } from './constants';

import styles from './Divider.module.scss';

export class Divider extends React.PureComponent {
    static propTypes = {
        /**
         * Color of divider
         */
        color: COLORS_PROP_TYPE,
        /**
         * Direction of divider (horizontal, vertical)
         */
        direction: DIVIDER_DIRECTIONS_PROP_TYPE,
        /**
         * Role of divider
         */
        role: PropTypes.string,
        /**
         * Custom CSS classname to apply to divider
         */
        customClassName: PropTypes.string,
    };

    static defaultProps = {
        color: 'ui-200',
        direction: 'horizontal',
    };

    render() {
        const { color, customClassName, direction, role } = this.props;

        const className = classNames(
            styles.root,
            {
                [styles.horizontal]: direction === 'horizontal',
                [styles.vertical]: direction === 'vertical',
            },
            customClassName,
        );

        // workaround to apply the eds-bg-color--${color} class
        let style = {};
        if (color && COLORS_MAP[color]) {
            style = {
                backgroundColor: COLORS_MAP[color],
            };
        }

        return (
            <hr
                className={className}
                data-testid="eds-divider"
                aria-hidden="true"
                role={role}
                style={style}
            />
        );
    }
}
